import script from "./AdminHomeImages.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminHomeImages.vue?vue&type=script&setup=true&lang=js"

import "./AdminHomeImages.vue?vue&type=style&index=0&id=581eefd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-581eefd0"]])

export default __exports__